import { FC } from 'react'
import styled from '@emotion/styled'
import { ModalCard } from 'src/v2/views/owner-reveal/insights/parcels/parcel-modal/modal-card'
import { DescriptionItem } from 'src/v2/components/description-item'
import { ParcelTypeChip } from 'src/v2/components/parcel-type-chip'
import * as atoms from 'src/v2/state/owner-reveal/entity-parcels'
import { useAtomValue } from 'jotai'
import { PARCEL_TYPES_BY_MCODE_MAP } from 'src/constants/cherre-data-dictionary/zoning-colors'
import { useGetParcelLinks } from 'src/v2/hooks/use-get-parcel-links'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ZoningCard: FC = () => {
  const data = useAtomValue(atoms.selectedParcelZoningDetails)
  const parcel = useAtomValue(atoms.selectedParcel)
  const { getParcelLinks, notFound: disableActionButton } = useGetParcelLinks(parcel)

  const openZoningPage = async () => {
    const links = await getParcelLinks()
    if (links?.zoningLink) {
      window.open(links.zoningLink, '_blank')
    }
  }

  if (!data) {
    return null
  }

  return (
    <ModalCard
      title="Zoning"
      actionText="Zoning Records"
      onActionClick={openZoningPage}
      actionDisabled={disableActionButton}>
      <Content>
        <DescriptionItem label="ZONE TYPE" value={<ParcelTypeChip type={PARCEL_TYPES_BY_MCODE_MAP[data.mCode]} />} />
        <DescriptionItem label="ZONE SUBTYPE" value={data.zoneDetails.zone_details.zone_sub_type} />
        <DescriptionItem label="ZONE NAME" value={data.zoneDetails.zone_details.zone_name} />
        <DescriptionItem label="ZONE CODE" value={data.zoneDetails.zone_details.zone_code} />
      </Content>
    </ModalCard>
  )
}
